export class LocalStorageConstant 
{
	public static readonly USER_ID: string = 'USER_ID';
	public static readonly AUTH_DATA: string = '@@STATE_FSM_AUTH';
	public static readonly AUTH_PULSE: string = '@@STATE_FSM_AUTH_PULSE';

	public static readonly IFAST_TV_DISCLAIMER: string = 'IFAST_TV_DISCLAIMER';

	public static readonly STOCK_TA_CHART_LAST_UPDATE_DATE: string = 'STOCK_TA_CHART_LAST_UPDATE_DATE';
}